export default __webpack_public_path__ + "static/media/placeholder_dummy2016-sportbekleidung01-de.1e0591c3.png";